"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DeliverCampaign;

var _react = _interopRequireWildcard(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _StreamsSelection = _interopRequireDefault(require("./MessageStreams/StreamsSelection"));

var _BriefsHelperMessage = _interopRequireDefault(require("./BriefsHelperMessage"));

var _BriefsHelperButton = _interopRequireDefault(require("./BriefsHelperButton"));

var _LandingPageCard = _interopRequireDefault(require("./LandingPageCard"));

var _actions = require("../../actions");

var _campaignCreatorContentHook = require("../../helpers/campaignCreatorContentHook");

var _useFeatureAccessHook = require("../../helpers/useFeatureAccessHook");

var _helpers = require("../../../helpers");

var _index = require("../../../index");

var _messageStreams = require("../../reducers/messageStreams");

var _mapping = require("../../reducers/mapping");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function DeliverCampaign(_ref) {
  var imageOne = _ref.imageOne,
      imageTwo = _ref.imageTwo,
      imageThree = _ref.imageThree;
  var SHOW_GENERATE_ADS = process.env.REACT_APP_CREATIVE_BRIEF_AD_GENERATOR || false;
  var dispatch = (0, _reactRedux.useDispatch)(); // $FlowFixMe

  var backRef = (0, _react.useRef)(null);
  var holdWidth = 73;

  if (backRef.current && backRef.current.ref && backRef.current.ref.current) {
    holdWidth = backRef.current.ref.current.clientWidth;
  }

  var deliverCampaignPermission = (0, _reactRedux.useSelector)(function (state) {
    return state.options.permissions.workflowPermission;
  });
  var campaignCreatorAccess = (0, _useFeatureAccessHook.useFeatureAccess)(deliverCampaignPermission);
  var pageTitle = (0, _campaignCreatorContentHook.usePageElement)('thirdLandingPage', 'pageTitle');
  var subTitle = (0, _campaignCreatorContentHook.usePageElement)('thirdLandingPage', 'subtitle');
  var firstImageIntroText = (0, _campaignCreatorContentHook.usePageElement)('thirdLandingPage', 'firstImageIntroText');
  var firstImageText = (0, _campaignCreatorContentHook.usePageElement)('thirdLandingPage', 'firstImageText');
  var secondImageIntroText = (0, _campaignCreatorContentHook.usePageElement)('thirdLandingPage', 'secondImageIntroText');
  var secondImageText = (0, _campaignCreatorContentHook.usePageElement)('thirdLandingPage', 'secondImageText');
  var thirdImageIntroText = (0, _campaignCreatorContentHook.usePageElement)('thirdLandingPage', 'thirdImageIntroText');
  var thirdImageText = (0, _campaignCreatorContentHook.usePageElement)('thirdLandingPage', 'thirdImageText');

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    return state.universes;
  }),
      currentUniverse = _useSelector.currentUniverse;

  var helperPage = 'deliver';
  (0, _react.useEffect)(function () {
    dispatch((0, _actions.loadOptions)());
    dispatch((0, _index.featureAccess)());
  }, [dispatch]);

  var _useSelector2 = (0, _reactRedux.useSelector)(_mapping.mappingQueryComposer),
      mappingQueryString = _useSelector2[0],
      isFetching = _useSelector2[1];

  var digitalAudiencesQueryString = (0, _reactRedux.useSelector)(_messageStreams.digitalAudiencesQueryComposer);

  var HelperMessage = /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, "Now that you have generated your Creative Briefs, the final step is to understand how to reach your audience, whether that be where they are geographically located or via what media they consume."), /*#__PURE__*/_react["default"].createElement("p", null, "Start by selecting the message stream of interest and then choose whether you would like to (a) map them or (b) profile their media consumption."), /*#__PURE__*/_react["default"].createElement("p", null, "Links will open in a new tab."));

  if (!campaignCreatorAccess) {
    return '';
  }

  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Container, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    width: 12
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "landing-page"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "creative-briefs--navigation creative-briefs--navigation__x-pad",
    style: {
      marginBottom: '1.5em'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
    ref: backRef,
    as: _reactRouterDom.Link,
    to: "message-streams"
  }, "Back"), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement("h1", {
    className: "campaign-creator--title"
  }, pageTitle), /*#__PURE__*/_react["default"].createElement(_BriefsHelperButton["default"], {
    page: helperPage
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: holdWidth
    }
  })), /*#__PURE__*/_react["default"].createElement(_BriefsHelperMessage["default"], {
    page: helperPage,
    message: HelperMessage
  }), /*#__PURE__*/_react["default"].createElement("h3", {
    className: "landing-page__sub-title landing-page__sub-title--cb"
  }, "1. Select Message Stream"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_StreamsSelection["default"], {
    showDownload: false,
    className: "message-streams--radio-group__boxed"
  })), /*#__PURE__*/_react["default"].createElement("h3", {
    className: "landing-page__sub-title landing-page__sub-title--cb"
  }, subTitle), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
    stackable: true,
    className: "landing-page__inner-grid"
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Row, {
    className: "landing-page__deliver-row"
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    tablet: 6,
    computer: 4
  }, /*#__PURE__*/_react["default"].createElement(_LandingPageCard["default"], {
    to: (0, _helpers.generateMappingURL)(currentUniverse, mappingQueryString),
    image: imageOne,
    introText: firstImageIntroText,
    title: firstImageText,
    openInTab: true,
    disabled: isFetching
  })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    tablet: 6,
    computer: 4
  }, /*#__PURE__*/_react["default"].createElement(_LandingPageCard["default"], {
    to: {
      pathname: "/creative-briefs/media-profile",
      search: '?useQuadrantPersonas=true'
    },
    image: imageTwo,
    introText: secondImageIntroText,
    title: secondImageText,
    openInTab: true
  })), SHOW_GENERATE_ADS && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    tablet: 6,
    computer: 4
  }, /*#__PURE__*/_react["default"].createElement(_LandingPageCard["default"], {
    to: {
      pathname: "/creative-briefs/generate-ads"
    },
    image: imageTwo,
    introText: "Build personalised Google or Facebook Ads on the fly.",
    title: "Generate Ad Copy",
    openInTab: true
  })))))), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Row, {
    style: {
      paddingTop: 0
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "creative-briefs--navigation creative-briefs--navigation__x-pad creative-briefs--navigation__back"
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
    as: _reactRouterDom.Link,
    to: "message-streams"
  }, "Back"))))));
}